<template>
  <div class="image-wrapper" :style="wrapperStyle">
    <BbSkeletonLoader v-if="!loaded" type="image" />

    <img v-show="loaded" :src="src" :alt="alt" @load="onLoad" @error="onError" />
  </div>
</template>

<script setup>
import { ref, computed, defineProps, defineEmits, watch } from 'vue';

const props = defineProps({
  src: String,
  alt: String,
  width: [String, Number],
  height: [String, Number],
});

const emit = defineEmits(['error']);

const loaded = ref(false);

const onLoad = () => (loaded.value = true);

const onError = () => {
  loaded.value = false;
  emit('error');
};

const wrapperStyle = computed(() => ({
  width: props.width ? `${props.width}px` : '100%',
  height: props.height ? `${props.height}px` : 'auto',
}));

watch(
  () => props.src,
  () => {
    loaded.value = false;
  },
);
</script>

<style scoped>
.image-wrapper {
  position: relative;
  overflow: hidden;

  .v-skeleton-loader {
    height: 100%;
    width: 100%;

    :deep(.v-skeleton-loader__image) {
      height: 100%;
    }
  }
}

@keyframes shimmer {
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: 200px 0;
  }
}

img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
